module.exports = __webpack_public_path__ + "img/map_wild-rag-deck.279dbca1.jpg";